import { CustomerFormValues } from '@/compoments/modals/AddCustomerModal'
import { baseApi } from '../baseApi'
import { ResponseType } from '../types'
import { Customer } from '@/types/dispatcher/dashboard.types'
import { Order } from '@/types/executives'
import { OrderFormValues } from '@/compoments/modals/AddOrderModal'

const base = 'api/customers'

export const customersApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        createAsDispatcher: builder.mutation<
            ResponseType<Customer>,
            CustomerFormValues
        >({
            query: body => ({
                url: `${base}/create-as-dispatcher`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['customers'],
        }),
        createOrderForCustomer: builder.mutation<
            ResponseType<Order>,
            { serviceId: number; customerId: number; body: OrderFormValues }
        >({
            query: ({ serviceId, customerId, body }) => ({
                url: `${base}/as-dispatcher/orders/${serviceId}/${customerId}`,
                method: 'POST',
                body,
            }),
        }),
    }),
})

export const {
    useCreateAsDispatcherMutation,
    useCreateOrderForCustomerMutation,
} = customersApi
